import template from './task-selection.html';
import controller from './task-selection.controller';

let TaskSelectionModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  controllerAs: '$ctrl',
  windowClass: "hmodal-info animated zoomIn"
};

export default TaskSelectionModal;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/task-selection/task-selection.component.js